import monitor from '@tencent/vft-monitor';
import LJReport from '@tencent/vft-speedreport/LJReport';
import env from '../env';

export default {
  fatal(params) {
    monitor.getMonitor('h5-login').fatal({
      modId: 'request_error',
      ...params,
    });
  },
  getPerf() {
    return new LJReport({ project: 'video_vip_fe', page: 'h5-login' });
  },
  perf({ modId, metrics, tags } = {}) {
    const reporter = new LJReport({ project: 'video_vip_fe', page: 'h5-login' });
    reporter.report({
      modId,
      metrics,
      tags: {
        device: env.device,
        app: env.app,
        ...tags,
      },
    });
  },
};
